import { useNavigate } from 'react-router-dom';

import { ActionButtonStyled } from './styled';

import clsx from 'clsx';
import Button from 'src/components/Button';

interface ActionButtonProps {
  className?: string;
  onClick?: () => void;
}

const ActionButton = ({ className, onClick }: ActionButtonProps) => {
  const navigate = useNavigate();
  return (
    <ActionButtonStyled className={clsx('ActionButton', className)}>
      <Button
        block
        size="large"
        onClick={() => {
          onClick && onClick();
        }}
      >
        그만하기
      </Button>
    </ActionButtonStyled>
  );
};

export default ActionButton;
